(function (c2) {
  'use strict';

  /* ── Modernized page (CMP-4062): datatable + trigger-point tree filter ── */

  // Current tree-filter scope, injected into every server-side request below.
  var orchParams = {};
  var orchSingle = false; // true when scoped to a single trigger point
  var orchSortUrl = null; // POST target that re-sequences run_seq on reorder

  // Drag-to-reorder is only meaningful within a single trigger point, so the
  // table rows are made sortable only then. On drop we POST the new id order to
  // sort_orch_actions (which rewrites run_seq).
  function applyReorderState($table) {
    var $tbody = $table.find('tbody');
    if (orchSingle && orchSortUrl) {
      $table.addClass('oa-reorderable');
      if ($tbody.hasClass('ui-sortable')) {
        $tbody.sortable('refresh');
        return;
      }
      $tbody.sortable({
        handle: '.oa-drag',
        items: '> tr',
        axis: 'y',
        containment: 'parent',
        tolerance: 'pointer',
        helper: function (e, ui) {
          // Lock cell widths so the dragged row keeps its layout.
          ui.children().each(function () { $(this).width($(this).width()); });
          return ui;
        },
        update: function () {
          var ids = $tbody
            .find('tr .oa-drag')
            .map(function () { return $(this).attr('data-oa-id'); })
            .get();
          if (ids.length) {
            $.post(orchSortUrl, { seq: ids }).fail(function () {
              if (c2.alerts) {
                c2.alerts.addGlobalAlert('Could not save the new order.', 'error', true, 5000);
              }
            });
          }
        }
      });
    } else {
      $table.removeClass('oa-reorderable');
      if ($tbody.hasClass('ui-sortable')) {
        $tbody.sortable('destroy');
      }
    }
  }

  function initDataTable(sortUrl) {
    var $table = $('#orchestration_actions');
    orchSortUrl = sortUrl;

    // Send the active tree-filter scope as plain query params alongside the
    // legacy params c2.dataTables builds from data-table-source (including the
    // ColumnControl filters on Type and Enabled), so re-scoping is just
    // ajax.reload() — no destroy/re-init, so the toolbar and column visibility
    // stay stable.
    $table.data('table-fnServerParams', function (aoData) {
      if (orchParams.category) { aoData.push({ name: 'category', value: orchParams.category }); }
      if (orchParams.hook_point) { aoData.push({ name: 'hook_point', value: orchParams.hook_point }); }
    });
    c2.dataTables.init('#orchestration_actions');

    // Move the scope label + Add button into the DataTable's toolbar row (the
    // top-start cell, beside the search box). The layout DOM is built
    // synchronously by DataTable() above, so it exists now.
    var $container = $table.closest('.dt-container');
    var $startCell = $container.find('.dt-layout-start').first();
    if (!$startCell.length) {
      $startCell = $container.find('.dt-search').closest('.dt-layout-row');
    }
    $startCell.append($('#oa-toolbar'));

    // Re-apply drag-sortable wiring whenever the rows are (re)drawn.
    $table.on('draw.dt', function () { applyReorderState($table); });

    var $tree = $('.oa-tree');
    $tree.on('click', '.oa-node', function () {
      var $n = $(this);

      // Category nodes expand/collapse their trigger points.
      if ($n.hasClass('oa-cat')) {
        $n.toggleClass('open');
        $tree
          .find('.oa-children[data-children-of="' + $n.data('category') + '"]')
          .toggle($n.hasClass('open'));
      }

      $tree.find('.oa-node').removeClass('active');
      $n.addClass('active');

      var scope = $n.data('scope');
      var single = false;
      var label = $n.find('.oa-label').text();
      orchParams = {};
      if (scope === 'category') {
        orchParams.category = $n.data('category');
      } else if (scope === 'hook_point') {
        orchParams.hook_point = $n.data('hook-point');
        single = true;
        label = $n.data('label');
      }

      orchSingle = single;
      var dt = $table.DataTable();
      // Trigger Point column (index 2) is redundant when scoped to one point.
      dt.column(2).visible(!single);
      // Re-wire the enable toggles on the freshly drawn (filtered) rows.
      dt.ajax.reload(function () {
        if (c2.toggles && c2.toggles.enablePostOnChange) {
          c2.toggles.enablePostOnChange('#orchestration_actions input[data-post-url]');
        }
      });

      var $add = $('#oa-add');
      var $scope = $('#oa-scope-label');
      if (single) {
        // For a single trigger point the tree already shows the context, so we
        // fold it into the Add button and drop the separate scope label.
        $scope.hide();
        $add
          .attr('href', $n.data('add-url'))
          .empty()
          .append('<i class="bi bi-plus-lg"></i> ')
          .append(document.createTextNode('Add ' + label + ' Action'))
          .show();
      } else {
        $scope.text(label).show();
        $add.hide();
      }
    });

    // Pre-select a tree node when the page is loaded with a hook_point (or
    // category) query param, e.g. linked from a parameter detail page that
    // wants to land directly on "Generated Parameter Options" already
    // scoped/expanded, instead of the default "All Actions" view.
    var initialParams = new URLSearchParams(window.location.search);
    var initialHookPoint = initialParams.get('hook_point');
    var initialCategory = initialParams.get('category');
    if (initialHookPoint) {
      var $hpNode = $tree.find('.oa-node.oa-hp[data-hook-point="' + initialHookPoint + '"]');
      if ($hpNode.length) {
        var $catNode = $tree.find('.oa-node.oa-cat[data-category="' + $hpNode.data('category') + '"]');
        if ($catNode.length && !$catNode.hasClass('open')) {
          $catNode.trigger('click');
        }
        $hpNode.trigger('click');
      }
    } else if (initialCategory) {
      $tree.find('.oa-node.oa-cat[data-category="' + initialCategory + '"]').trigger('click');
    }
  }

  c2.orchestrationActions = {
    initDataTable: initDataTable
  };

})(window.c2);
